import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { I18nProvider } from './i18n'
import './index.css'
import { StoreProvider } from './store'

const root = document.getElementById('root')
if (!root) throw new Error('找不到 #root')

createRoot(root).render(
  <StrictMode>
    <StoreProvider>
      <I18nProvider>
        <App />
      </I18nProvider>
    </StoreProvider>
  </StrictMode>,
)

// Service worker 只缓存 app 外壳，让加到主屏后没网也能打开。
// 数据一律走网络，不缓存 —— 缓存住的周期数据可能是过期的，那比看不到更糟。
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
